import type {BlindLevel} from '../../types/domain'
import React from 'react'
import {Box, Stack, Typography} from '@mui/material'

const amount = (value: number) => value >= 1000 ? `${value / 1000}K` : value
export default function Blind({blind, isNextLevel = false}: {blind: BlindLevel; isNextLevel?: boolean}) {
  const ante = blind.ante ?? 0
  const hasAnte = ante > 0
  if (isNextLevel) return <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
    <Typography color="text.secondary">Next Round:</Typography>
    <Typography component="output" aria-label="Next small blind">{amount(blind.smallBlind)}</Typography>
    <Typography>/</Typography>
    <Typography component="output" aria-label="Next big blind">{amount(blind.bigBlind)}</Typography>
    {hasAnte && <>
      <Typography color="text.secondary">Ante:</Typography>
      <Typography component="output" aria-label="Next ante">{amount(ante)}</Typography>
    </>}
  </Stack>
  return <Box sx={{display: 'grid', gridTemplateColumns: `repeat(${hasAnte ? 3 : 2}, 1fr)`, textAlign: 'center'}}>
    {([{label: 'Small blind', value: blind.smallBlind}, {label: 'Big blind', value: blind.bigBlind}, ...(hasAnte ? [{label: 'Ante', value: ante}] : [])]).map((item, index) => <Box key={item.label} sx={{minWidth: 0, borderLeft: index ? 1 : 0, borderColor: 'divider'}}>
      <Typography variant="overline" color="text.secondary" sx={{letterSpacing: {xs: 1, sm: 2}, fontSize: 'var(--timer-label-font, 0.75rem)'}}>{item.label}</Typography>
      <Typography component="output" aria-label={item.label} sx={{display: 'block', fontSize: `var(--timer-blind-font, clamp(2rem, ${hasAnte ? 10 : 14}vw, 4rem))`, overflowWrap: 'anywhere', fontWeight: 700, fontVariantNumeric: 'tabular-nums'}}>{amount(item.value)}</Typography>
    </Box>)}
  </Box>
}
